import { render, staticRenderFns } from "./rooter.vue?vue&type=template&id=ca310ddc"
import script from "./rooter.vue?vue&type=script&lang=js"
export * from "./rooter.vue?vue&type=script&lang=js"
import style0 from "./rooter.vue?vue&type=style&index=0&id=ca310ddc&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports